 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-login-login-module":"pages-login-login-module","pages-menu-menu-module":"pages-menu-menu-module","core-js-js":"core-js-js","css-shim-978387b1-1e75855f-js":"css-shim-978387b1-1e75855f-js","dom-76cc7c7d-0a082895-js":"dom-76cc7c7d-0a082895-js","dom-js":"dom-js","shadow-css-4889ae62-23996f3f-js":"shadow-css-4889ae62-23996f3f-js","swiper-bundle-ccdaac54-js":"swiper-bundle-ccdaac54-js","ios-transition-1850e475-js":"ios-transition-1850e475-js","md-transition-083fcf52-js":"md-transition-083fcf52-js","focus-visible-70713a0c-js":"focus-visible-70713a0c-js","hardware-back-button-5afe3cb0-js":"hardware-back-button-5afe3cb0-js","input-shims-a4fc53ac-js":"input-shims-a4fc53ac-js","status-tap-839e1402-js":"status-tap-839e1402-js","swipe-back-c7acdfde-js":"swipe-back-c7acdfde-js","tap-click-606f325e-js":"tap-click-606f325e-js","chat-chat-module":"chat-chat-module","customer-offer-confirmation-item-detail-customer-offer-confirmation-item-detail-module":"customer-offer-confirmation-item-detail-customer-offer-confirmation-item-detail-module","customer-offer-item-detail-customer-offer-item-detail-module":"customer-offer-item-detail-customer-offer-item-detail-module","order-overview-order-overview-module":"order-overview-order-overview-module","position-detail-position-detail-module":"position-detail-position-detail-module","task-management-task-management-module":"task-management-task-management-module","tool-data-sheet-module-tool-data-sheet-module-module":"tool-data-sheet-module-tool-data-sheet-module-module","tool-data-sheet-tool-data-sheet-module":"tool-data-sheet-tool-data-sheet-module","warehouse-settings-warehouse-settings-module":"warehouse-settings-warehouse-settings-module","customer-list-customer-list-module":"customer-list-customer-list-module","customer-offer-confirmation-customer-offer-confirmation-module":"customer-offer-confirmation-customer-offer-confirmation-module","customer-offer-confirmation-detail-customer-offer-confirmation-detail-module":"customer-offer-confirmation-detail-customer-offer-confirmation-detail-module","customer-offer-customer-offer-module":"customer-offer-customer-offer-module","dashboard-order-dashboard-order-module":"dashboard-order-dashboard-order-module","default~add-customer-add-customer-module~customer-detail-customer-detail-customer-detail-module":"default~add-customer-add-customer-module~customer-detail-customer-detail-customer-detail-module","customer-detail-customer-detail-customer-detail-module":"customer-detail-customer-detail-customer-detail-module","default~add-other-contact-add-other-contact-module~other-contact-other-contact-detail-other-contact-~267aeb16":"default~add-other-contact-add-other-contact-module~other-contact-other-contact-detail-other-contact-~267aeb16","other-contact-other-contact-detail-other-contact-detail-module":"other-contact-other-contact-detail-other-contact-detail-module","default~add-supplier-add-supplier-module~supplier-detail-supplier-detail-supplier-detail-module":"default~add-supplier-add-supplier-module~supplier-detail-supplier-detail-supplier-detail-module","supplier-detail-supplier-detail-supplier-detail-module":"supplier-detail-supplier-detail-supplier-detail-module","default~document-detail-document-detail-module~document-overview-document-overview-module":"default~document-detail-document-detail-module~document-overview-document-overview-module","default~document-overview-document-overview-module~mobile-chat-mobile-chat-module~mobile-work-steps-~1af1f8df":"default~document-overview-document-overview-module~mobile-chat-mobile-chat-module~mobile-work-steps-~1af1f8df","document-overview-document-overview-module":"document-overview-document-overview-module","default~mobile-chat-mobile-chat-module~mobile-work-steps-mobile-work-steps-module":"default~mobile-chat-mobile-chat-module~mobile-work-steps-mobile-work-steps-module","mobile-chat-mobile-chat-module":"mobile-chat-mobile-chat-module","mobile-work-steps-mobile-work-steps-module":"mobile-work-steps-mobile-work-steps-module","delivery-list-delivery-list-module":"delivery-list-delivery-list-module","email-detail-email-detail-module":"email-detail-email-detail-module","email-list-email-list-module":"email-list-email-list-module","group-list-group-list-module":"group-list-group-list-module","home-home-module":"home-home-module","inquiry-inquiry-module":"inquiry-inquiry-module","item-detail-item-detail-module":"item-detail-item-detail-module","item-list-item-list-module":"item-list-item-list-module","management-module-confirmation-management-module-confirmation-module":"management-module-confirmation-management-module-confirmation-module","management-module-management-module-module":"management-module-management-module-module","management-module-offer-management-module-offer-module":"management-module-offer-management-module-offer-module","mobile-notes-mobile-notes-module":"mobile-notes-mobile-notes-module","mobile-task-list-mobile-task-list-module":"mobile-task-list-mobile-task-list-module","mobile-timetracking-mobile-timetracking-module":"mobile-timetracking-mobile-timetracking-module","monthly-view-monthly-view-module":"monthly-view-monthly-view-module","offer-detail-offer-detail-module":"offer-detail-offer-detail-module","other-contact-list-other-contact-list-module":"other-contact-list-other-contact-list-module","profile-profile-module":"profile-profile-module","request-detail-request-detail-module":"request-detail-request-detail-module","supplier-inquiry-supplier-inquiry-module":"supplier-inquiry-supplier-inquiry-module","team-overview-team-overview-module":"team-overview-team-overview-module","time-tracking-time-tracking-module":"time-tracking-time-tracking-module","user-list-user-list-module":"user-list-user-list-module","add-customer-add-customer-module":"add-customer-add-customer-module","add-supplier-add-supplier-module":"add-supplier-add-supplier-module","add-other-contact-add-other-contact-module":"add-other-contact-add-other-contact-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
